import { ApiUrl } from "common/services";
export const QuoteUploadLookupUrl = `${ApiUrl}/quote/search`;
export const QuoteDownloadUrl = `${ApiUrl}/quote/download`;
